module.exports = __webpack_public_path__ + "public/Icons/automobile-with-wrench.svg?0a0ee231";